/**
 * for www
 * initTrackers를 외부에서 호출하지 않는 현재 방식을 유지하기 위해...
 */

import { setTrackerVariableToGivenContext, track, register, TRACKER_CLASS_MAP } from './common';
import { TrackerEvent } from './tracker-event';
import config from './config';

// 전역변수 `$fc`에 `tracker()` & `track()` 함수 주입.
const initTrackers = (context) => {
  const completeInitiatingTracker = new window.Event('completeInitiatingTracker');
  setTrackerVariableToGivenContext(window);
  for (const trackerName of Object.keys(TRACKER_CLASS_MAP.www)) {
    register({
      Tracker: TRACKER_CLASS_MAP.www[trackerName],
      config: config[trackerName.toLowerCase()],
      ...context,
    });
  }
  window.dispatchEvent(completeInitiatingTracker);
};
export { track, register, initTrackers, TrackerEvent };
